(function () {

    angular
        .module('app')
        .service('loggerService', loggerService);

    loggerService.$inject = [
        'downloadService',
        '$log', '$location', '$rootScope', '$window'
    ];


    function loggerService(downloadService, $log, $location, $rootScope, $window) {

        var logs = [];

        function safeStringify(obj) {
            try {
                return JSON.stringify(obj);
            }
            catch (err) {
                return 'Unable to stringify object';
            }
        }

        function capture() {
            for (var i = 0; i < arguments.length; i++) {
                var nextarg = arguments[i];
                if (nextarg instanceof Error) {
                    nextarg = safeStringify({
                        name: nextarg.name,
                        message: nextarg.message,
                        stack: nextarg.stack
                    });
                }
                else if (nextarg && nextarg.reason && nextarg.reason.name && nextarg.reason.message) {
                    nextarg = safeStringify({
                        name: nextarg.reason.name,
                        message: nextarg.reason.message,
                        stack: nextarg.reason.stack
                    });
                }
                else if (nextarg instanceof ErrorEvent) {
                    nextarg = safeStringify({
                        evt: 'ErrorEvent',
                        message: nextarg.message,
                        filename: nextarg.filename,
                        lineno: nextarg.lineno,
                        colno: nextarg.colno
                    });
                }
                else if (nextarg instanceof Event) {
                    var target = nextarg.target;
                    nextarg = safeStringify({
                        evt: 'Event',
                        type: nextarg.type,
                        src: target && (target.src || target.href || target.nodeName)
                    });
                }
                else if (typeof nextarg !== 'string') {
                    nextarg = safeStringify(nextarg);
                }
                logs.push(Date.now() + ' ' + nextarg + '\n');
            }
        }

        function downloadLog() {
            logs.push('[ml4klog] site host ');
            logs.push($window.location.href);
            logs.push('\n[ml4klog] url parameters ');
            logs.push(JSON.stringify(urlParms));
            logs.push('\n[ml4klog] browser ');
            logs.push(navigator.userAgent);
            logs.push('\n[ml4klog] version v=360');

            downloadService.downloadFile(logs, 'text/plain', 'mlforkids.log');
        }

        $log.debug('[ml4klog] Initialising logger service');

        window.addEventListener('error', capture);
        window.addEventListener('unhandledrejection', capture);

        var urlParms = $location.search();
        $log.debug('[ml4klog] site host', $window.location.href);
        $log.debug('[ml4klog] url parameters', urlParms);

        if (urlParms && urlParms.debug) {
            logs = [];
            $rootScope.debugLogging = true;
            return {
                error : capture,
                warn : capture,
                debug : capture,

                download : downloadLog
            };
        }
        else {
            logs = [];
            $rootScope.debugLogging = false;
            return {
                error : $log.error,
                warn : $log.warn,
                debug : $log.debug
            };
        }
    }
})();
